import React, { useEffect } from "react";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const PaginationButton = ({ val, onChange, min = 0, max = Infinity }) => {
  const [number, setNumber] = useState(val ?? min);

  useEffect(() => {
    setNumber(val ?? min);
  }, [val, min]);

  const add = () => {
    const newVal = Math.min(max, number + 1);
    setNumber(newVal);
    onChange(newVal);
  };

  const remove = () => {
    const newVal = Math.max(min, number - 1);
    setNumber(newVal);
    onChange(newVal);
  };

  const formattedNumber = String(number).padStart(2, "0");
  const isMin = number <= min;
  const isMax = number >= max;

  return (
    <div className="flex items-center gap-4">
      {/* <div className="border rounded-md p-1 cursor-pointer" onClick={remove}>
        <Minus color="grey" style={{ width: "16px", height: "16px" }} />
      </div> */}
      <div
        onClick={remove}
        className={`border rounded-md p-1 ${
          isMin ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        <Minus
          color={isMin ? "#d1d5db" : "grey"}
          style={{ width: "16px", height: "16px" }}
        />
      </div>
      <div>{formattedNumber}</div>
      {/* <div className="border rounded-md p-1 cursor-pointer" onClick={add}>
        <Plus color="grey" style={{ width: "16px", height: "16px" }} />
      </div> */}
      <div
        onClick={add}
        className={`border rounded-md p-1 ${
          isMax ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        <Plus
          color={isMax ? "#d1d5db" : "grey"}
          style={{ width: "16px", height: "16px" }}
        />
      </div>
    </div>
  );
};

export default PaginationButton;
